export default __webpack_public_path__ + "08820fd9b17a8aefae41f47e693441a2.png";